import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {
  supplierPaymentTerm: string;
  supplierPaymentTermInstruction: string;
}

@Component({
  selector: 'app-payment-terms-conditions',
  templateUrl: './payment-terms-conditions.component.html',
  styleUrls: ['./payment-terms-conditions.component.scss']
})
export class PaymentTermsConditionsComponent implements OnInit {
  termsForm: FormGroup;
  partnerPaymentTerms:any;
  isSubmitted: boolean;

  constructor(
    private dialogref: MatDialogRef<PaymentTermsConditionsComponent>,
    private toastr: ToastrService,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.termsForm = this._formBuilder.group({
      partnerPaymentTerms: [this.data.supplierPaymentTerm, Validators.required],
      payment_string:[this.data.supplierPaymentTermInstruction],
    });

  }


  close() {
    this.dialogref.close();
  }


  submit() {
    this.isSubmitted = true;
    if (this.termsForm.invalid) {
      return false;
    } else {
    let formData = this.termsForm.get('partnerPaymentTerms').value
    let form = {
      "partnerPaymentTerms": formData,
      "supplierPaymentTermInstruction": this.termsForm.get('payment_string').value
    }
    console.log(this.termsForm);
    this.dialogref.close({data:form});
    // this.adminService.updateTermsConditions(form).subscribe(
    //   res => {
    //     this.toastr.success('Updated Terms & Conditions', 'Success');
    //     this.dialogref.close({data:form});
    //   },
    //   err => {
    //     this.toastr.error('Something Went Wrong', 'Error');
    //   }
    // )
    }

  }

  
  paymentTermList = ["50% Advance","50% post acceptance of material","100% Advance", "100% Before Shipment", "Net 15 ", "Net 30", "Net 45 ", "Custom"];

}

